<app-top-nav [data]="isLoggedIn$ | async"></app-top-nav>

<main class="min-vh-100 mb-5 pb-5">
    <router-outlet></router-outlet>
</main>

<app-footer></app-footer>